import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment';
import { WfFeaturesService } from '@app/services/wf-features.service';
import { TourGuideService } from '@app/services/tour-guide.service';
import dummyData from '@app/assets/api-dummy-data.json'
import { TourGuideContent } from '@app/util/tour-guide-content.util';

@Component({
  selector: 'app-quality-gates-fe-wf',
  templateUrl: './quality-gates-fe-wf.component.html',
  styleUrls: ['./quality-gates-fe-wf.component.scss']
})

export class QualityGatesFeWfComponent implements OnInit {

  /****************** Variable declaration ******************/
  columnHeaders = ['Tool', 'Quality gate', 'Threshold', 'Result', 'Status']
  columnsToDisplay = ['tool', 'qualityGateName', 'actualThreshold', 'execThreshold', 'status'];
  tourId = TourGuideContent;

  /****************** Input and Output decorators ******************/
  @Input() jobId!: string;
  @Input() dataSource: any = [];
  @Input() useDs = false;

  /**
   * Constructor
   * @param featureWf 
   * @param guideService 
   */
  constructor(private featureWf: WfFeaturesService,
    private guideService: TourGuideService) {
  }

  /** ngOnInit */
  ngOnInit() { }

  ngOnChanges() {
    if (this.guideService.isStartTour) {
      this.dataSource = dummyData.feature_workFlow.qualityGates;
      this.dataSource.map((ds: any) => ds.startTime = moment(ds.startTime));
      return;
    }
    if (!this.useDs) {
      this.featureWf.getWfQgRes(this.jobId).subscribe((response: any) => {
        this.dataSource = response.data.dbResp;
        this.dataSource.map((ds: any) => ds.startTime = moment(ds.startTime));
      });
    }
  }
}

/**
 * **************************************************
 * Interface for QualityGates
 * **************************************************
 */
export interface QualityGate {
  actualThreshold: number;
  execThreshold: number;
  id: number;
  qualityGateName: String;
  status: String;
}
